import { Leaf } from "lucide-react";
import { MARQUEE } from "@/data/content";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="marquee-strip" className="overflow-hidden border-y border-stone2 bg-cream py-4">
      <div className="flex w-max animate-marquee items-center gap-12">
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-12 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.28em] text-pine"
          >
            {item}
            <Leaf size={13} className="text-lime-600" />
          </span>
        ))}
      </div>
    </div>
  );
}
